<template>
  <ImageWrapper
    imagePath="assets/images/Teaser_Account"
    imageName="Teaser_Account"
    :breakpoints="[300, 300, 353, 353, 353]"
  ></ImageWrapper>
</template>

<script setup lang="ts">
import ImageWrapper from '@/components/rahmen/ImageWrapper.vue'
</script>
